import { render, staticRenderFns } from "./DragArea.vue?vue&type=template&id=0a8c68de&"
import script from "./DragArea.vue?vue&type=script&lang=js&"
export * from "./DragArea.vue?vue&type=script&lang=js&"
import style0 from "./DragArea.vue?vue&type=style&index=0&id=0a8c68de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports